/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Tea_Purchase_PlaceholderInputs */

const vi_pl_pnk_tea_purchase_placeholder = /** @type {(inputs: Pl_Pnk_Tea_Purchase_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn đơn mua đã xử lý...`)
};

/**

* @param {Pl_Pnk_Tea_Purchase_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_tea_purchase_placeholder = /** @type {((inputs?: Pl_Pnk_Tea_Purchase_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Tea_Purchase_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_tea_purchase_placeholder(inputs)
});